// extracted by mini-css-extract-plugin
module.exports = {"Container":"Dashboard_Container__NMUlD","appBar_root":"Dashboard_appBar_root__18_Pd","title":"Dashboard_title___JLYB"};